import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "product-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
import { onMounted, onUnmounted, ref } from "vue";
import "../../styles/home/Product.scss";
//宣传图  优化
export default /*#__PURE__*/_defineComponent({
  __name: 'MyProduct',
  setup(__props) {
    const carouselItems = ref([{
      imageLeft: 'http://ocr.nbdj.cc/test/c4-image-test.png',
      imageRight: 'http://ocr.nbdj.cc/test/c4-images-right.png',
      theme: 0,
      href: "article/detail/21"
    }, {
      imageLeft: 'http://ocr.nbdj.cc/test/web-scanner-image.png',
      imageRight: 'http://ocr.nbdj.cc/test/web-scanner-image-right.png',
      theme: 1,
      href: "/article/detail/17"
    }, {
      imageLeft: 'http://ocr.nbdj.cc/test/ppt-banner-left.png',
      imageRight: 'http://ocr.nbdj.cc/test/ppt-banner-right.png',
      theme: 1,
      href: "/article/detail/20"
    }
    // {imageLeft: 'http://ocr.nbdj.cc/test/ps-image-left.png', imageRight: 'http://ocr.nbdj.cc/test/ps-image-right.png', theme: 1,href:"/business/ps"},
    ]);
    // //宣传图
    // const carouselItems = ref([
    //   {imageLeft: 'c4-image-test.png', imageRight: 'c4-images-right.png', theme: 0,href:"article/detail/21"},
    //   {imageLeft: 'web-scanner-image.png', imageRight: 'web-scanner-image-right.png', theme: 1,href:"/article/detail/17"},
    //   {imageLeft: 'ppt-banner-left.png', imageRight: 'ppt-banner-right.png', theme: 1,href:"/article/detail/20"},
    //   {imageLeft: 'ps-image-left.png', imageRight: 'ps-image-right.png', theme: 1,href:"/business/ps"},
    // ]);
    const screenWidth = ref(window.innerWidth); // 屏幕的宽度
    const bannerHeight = ref(100); // 图片父容器的高度
    // 通过屏幕宽度(图片宽度)计算高度
    const setSize = () => {
      bannerHeight.value = 600 / 1900 * screenWidth.value;
    };
    //通过计算获取主题是黑还是白
    const getBannerStyle = theme => {
      return theme % 2 === 0 ? 'banner-item-black' : 'banner-item-white';
    };
    const getCarouselContainerClass = theme => {
      return theme % 2 === 0 ? 'carousel-container-black' : 'carousel-container-white';
    };
    const getOverlayContentClass = theme => {
      return theme % 2 === 0 ? 'overlay-content-black' : 'overlay-content-white';
    };
    onMounted(() => {
      setSize();
      window.addEventListener('resize', () => {
        screenWidth.value = window.innerWidth;
        setSize();
      });
    });
    onUnmounted(() => {
      window.removeEventListener('resize', () => {
        screenWidth.value = window.innerWidth;
        setSize();
      });
    });
    return (_ctx, _cache) => {
      const _component_RouterLink = _resolveComponent("RouterLink");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        height: bannerHeight.value + 'px',
        class: "banner"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselItems.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: index,
            class: _normalizeClass(getBannerStyle(item.theme))
          }, {
            default: _withCtx(() => [_createVNode(_component_RouterLink, {
              to: item.href
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(getCarouselContainerClass(item.theme))
              }, [_createElementVNode("img", {
                src: item.imageLeft,
                alt: "",
                class: "carousel-image"
              }, null, 8, _hoisted_2), _createElementVNode("img", {
                src: item.imageRight,
                alt: "",
                class: _normalizeClass(getOverlayContentClass(item.theme))
              }, null, 10, _hoisted_3)], 2)]),
              _: 2
            }, 1032, ["to"])]),
            _: 2
          }, 1032, ["class"]);
        }), 128))]),
        _: 1
      }, 8, ["height"])]);
    };
  }
});